import { Directive, ElementRef, OnInit, inject } from '@angular/core';
import { customScrollBarStyles } from '../../constants';

@Directive({ selector: '[appIonScrollBar]', standalone: true })
export class IonScrollBarDirective implements OnInit {
  elementRef = inject(ElementRef);

  hostElement: HTMLElement | undefined;

  ngOnInit() {
    this.hostElement = this.elementRef.nativeElement;
    if (this.hostElement && this.hostElement.tagName && this.hostElement.tagName == 'ION-CONTENT') {
      const el = document.createElement('style');
      el.innerText = customScrollBarStyles;
      this.hostElement?.shadowRoot?.appendChild(el);
    }
  }
}
